import type { ReactNode } from "react";

/**
 * Palet (README §2.2): 24 px başlık bandı (10/600/BÜYÜK) + gövde + isteğe bağlı alt bant.
 * Yerleşim: sol dock (268), sağ dock (300), yüzen (326; `position:absolute`, sürüklenebilir başlık).
 */
export function Palette({ title, id, children, footer, actions, className = "", bodyClassName = "", style, headerProps, as: Tag = "section" }: {
  title: ReactNode; id?: string; children: ReactNode; footer?: ReactNode; actions?: ReactNode; className?: string; bodyClassName?: string; style?: React.CSSProperties;
  headerProps?: React.HTMLAttributes<HTMLDivElement>;
  /** `aside` = tamamlayıcı panel (rapor ayarları); varsayılan `section` (region) */
  as?: "section" | "aside";
}): JSX.Element {
  return (
    <Tag id={id} aria-label={typeof title === "string" ? title : undefined} className={`flex flex-col min-h-0 bg-cad-panel ${className}`} style={style}>
      <div className="cad-head select-none" {...headerProps}>
        <span className="truncate">{title}</span>
        {actions ? <span className="ml-auto flex items-center gap-1 text-cad-ink3 normal-case tracking-normal font-normal">{actions}</span> : null}
      </div>
      <div className={`flex-1 min-h-0 overflow-auto ${bodyClassName}`}>{children}</div>
      {footer ? <div className="border-t border-cad-line px-1.5 py-1 bg-cad-sub text-cad-ink3 text-[10px]">{footer}</div> : null}
    </Tag>
  );
}

/** Palet başlık düğmesi (dock / kapat) */
export function PaletteButton({ label, onClick, children }: { label: string; onClick: () => void; children: ReactNode }): JSX.Element {
  return <button type="button" aria-label={label} title={label} onClick={onClick} className="cad-hit w-4 h-4 inline-flex items-center justify-center rounded-[2px] text-cad-ink3 hover:bg-cad-hover hover:text-cad-ink cursor-pointer text-[11px] leading-none">{children}</button>;
}
